// hooks/useSessionTimeout.js
// Session timeout: redirect ke login setelah lama tidak aktif (default 24 jam)

import { useEffect, useRef, useCallback } from "react";

const INACTIVITY_TIMEOUT_MS = 24 * 60 * 60 * 1000; // 24 jam

const getIsPublicRoute = () => {
  const hash = window.location.hash || "";
  return (
    hash.includes("/survey/") ||
    hash.includes("/publik/") ||
    hash.includes("/download/")
  );
};

export const useSessionTimeout = (navigate, options = {}) => {
  const timeoutMs = options.timeoutMs || INACTIVITY_TIMEOUT_MS;
  const timerRef = useRef(null);

  const clearSession = useCallback(() => {
    localStorage.removeItem("user");
    localStorage.removeItem("accessToken");
    if (navigate && !getIsPublicRoute()) {
      navigate("/authentication/sign-in/cover", { replace: true });
    }
  }, [navigate]);

  const resetTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(clearSession, timeoutMs);
  }, [timeoutMs, clearSession]);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user || getIsPublicRoute()) return;

    resetTimer();

    const events = ["mousedown", "mousemove", "keydown", "scroll", "touchstart"];
    const handleActivity = () => resetTimer();

    events.forEach((ev) => window.addEventListener(ev, handleActivity));

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((ev) => window.removeEventListener(ev, handleActivity));
    };
  }, [resetTimer]);
};
